import { RecommendedProductsType } from '~app/modules/catalog/models';

export const RECOMMENDED_PRODUCTS_TITLE: {[key in keyof typeof RecommendedProductsType]: string} = {
  RemovedFilters: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.FILTER',
  ParentCategory: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.CATEGORY',
  ExpandedSearch: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.EXPANDED_SEARCH',
  PromoItems: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.PROMO',
  MostPopularProducts: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.MOST_POPULAR_PRODUCTS',
  MostRelevantProducts: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.MOST_RELEVANT_PRODUCTS',
  ParsedTextProducts: 'CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.PARSED_TEXT_PRODUCTS'
};
